import { render, staticRenderFns } from "./SectionLocaleEditor.vue?vue&type=template&id=78d00ec0"
import script from "./SectionLocaleEditor.vue?vue&type=script&lang=ts"
export * from "./SectionLocaleEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports